import {
    Component, Prop, Vue, PropSync, Provide, Watch, Inject, Emit, Model, ProvideReactive, InjectReactive,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vuex, { mapState, mapGetters } from 'vuex';
import {
    Module, VuexModule, Mutation, Action, getModule, MutationAction,
} from 'vuex-module-decorators';
import store from '@/state/store';
import EventBus from '@/utils/event-bus';

export {
    Component,
    Prop,
    Vue,
    Vuex,
    mapState,
    Module,
    VuexModule,
    Mutation,
    Action,
    getModule,
    store,
    MutationAction,
    PropSync,
    Provide,
    Watch,
    Inject,
    Emit,
    Model,
    EventBus,
    mixins,
    ProvideReactive,
    InjectReactive,
};
